import React, { useState, useEffect, useRef } from "react";
import { Container,Form, Row, Col, Button } from 'react-bootstrap';
import {GLOBAL_DOMAIN, Api_Headers, PAYTM_SCRIPT_ID} from '../../../Config/Config';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from 'axios';
import Header from "../../../Components/Header/Header";
import { Payment_Gateway } from "../../../Config/Config";
import { Toast } from 'primereact/toast';
import { initializeTPL } from "../../../Components/Tpl";

const Wallet = () => {
    const [walletTransactions, setWalletTransactions] = useState([]);
    const [userData, setUserData] = useState('');
    const [walletAmount, setWalletAmount] = useState(0);
    const [addAmount, setAddAmount] = useState(0);
    const user_data = JSON.parse(window.localStorage.getItem('User_data'));
    const toast = useRef(null);

    useEffect(() => {
    getUserData();
     getUserTransactions();
//     initializeTPL(PAYTM_SCRIPT_ID);
    }, []);
    
    const getUserData = ()=>{
        axios({
            method: 'get',
            headers: Api_Headers,
            url: GLOBAL_DOMAIN + '/v1/endusers/' + user_data.data.userData.ID,
        }).then((res) => {
            setUserData(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    const getUserTransactions = ()=>{
        axios({
            method: 'get',
            headers: Api_Headers,
            url: GLOBAL_DOMAIN + '/v1/usertransactions?type=list&limit=100&userId='+user_data.data.userData.ID, 
        }).then((res) => {
            setWalletTransactions(res.data.rows);
        }).catch((err) => {
            console.log(err);
        });
    }
    const addAmountToWallet =()=>{
        // console.log('at config level:userData.ID ',userData.ID);
        axios({
            method: 'POST',
            headers: Api_Headers,
            url: GLOBAL_DOMAIN + '/v1/paymentgateway/generateWebToken',
            data: {
              'ORDER_TOTAL_AMOUNT': `${addAmount}`,
              'USER_ID': user_data.data.userData.ID,
            }
        }).then((res) => {
            // console.log('at config level:orderid ',res.data.data.orderInfo.ORDER_ID);
            // console.log('at config level:txnToken ',res.data.data.txnToken);
            // console.log('at config level:ORDER_TOTAL_AMOUNT ',res.data.data.orderInfo.ORDER_TOTAL_AMOUNT);
            const checksumInfo =  JSON.parse(res.data.paytmchecksum);
            var config = {
                "root":"",
                "style": {
                    "bodyBackgroundColor": "#fff",
                    "bodyColor": "#333",
                    "themeBackgroundColor": "#77cab9",
                    "themeColor": "#fff",
                    "headerBackgroundColor": "#77cab9",
                    "headerColor": "#fff",
                    "errorColor": "red",
                    "successColor": "green",
                    "card": {
                        "padding": "",
                        "backgroundColor": "",
                    }
                },
                "data": {
                    "orderId": `${res.data.data.orderInfo.ORDER_ID}`,
                    "token": `${res.data.data.txnToken}`,
                    "tokenType": "TXN_TOKEN",
                    "amount": `${res.data.data.orderInfo.ORDER_TOTAL_AMOUNT}`,
                },
                "payMode": {
                    "labels": {},
                    "filter": {
                        "exclude": [
                            "WALLET",
                            "BANK_MANDATE",
                            "BANK_TRANSFER",
                            "DEBIT_CARD",
                            "EMI",
                            "EMI_DC",
                            "MGV",
                            "LOGIN",
                            "PPBL",
                            "PDC",
                            "SC",
                            "BALANCE"
                        ]
                    },
                    "order": [ 
                        "CARD",
                        "NB",
                        "UPI"
                    ]
                },
                "website": "WEB",
                "flow": "DEFAULT",
                "merchant": {
                    "mid": Payment_Gateway.MERCHANT_ID,
                    'name': 'ATUM Life',
                    "redirect": false,
                },
               
                "handler": {
                    "transactionStatus":function transactionStatus(paymentStatus) {
                        window.Paytm.CheckoutJS.close();
                        let datas = {
                            "USER_ID": userData.ID,
                            "ORDER_ID": paymentStatus.ORDERID,
                            "TRANSACTION_ID": paymentStatus.TXNID,
                            "PAYMENT_TYPE": "CREDIT",
                            "GATEWAY_NAME": paymentStatus.GATEWAYNAME,
                            "ORDER_AMOUNT": parseInt(paymentStatus.TXNAMOUNT),
                            "CREATED_BY": userData.ID,
                            "UPDATED_BY": userData.ID,
                        }; console.log('body: ',datas);
                        if(paymentStatus.STATUS == 'TXN_SUCCESS'){
                        axios({
                            method: 'post',
                            headers: Api_Headers,
                            url: GLOBAL_DOMAIN+'/v1/usertransactions',
                            data: datas,
                        }).then((res) => {
                            setAddAmount(0);
                            getUserTransactions();
                            getUserData();
                        }).catch((err) => {
                            console.log(err);
                        });
                    }else{
                        showtoast()
                    }
                    },
                    "notifyMerchant": function notifyMerchant(eventName, data) {
                        window.Paytm.CheckoutJS.close();
                    },
                },
            };

            if (window.Paytm && window.Paytm.CheckoutJS) {
                window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
                    window.Paytm.CheckoutJS.invoke();
                }).catch(function onError(err) {
                    console.log("Error => ", err);
                });
            };
        }).catch((err) => {
        window.Paytm.CheckoutJS.invoke();   
        });
    };

    const amtBody = (row) => {
        return `₹ ${row.ORDER_AMOUNT}`
    };

    const dateBody = (row) => {
        var d = new Date(row.CREATED_AT);
        return d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear();
    };

    const ptBody = (row) => {
        return( 
            row.PAYMENT_TYPE==='CREDIT' ? <div style={{color: 'forestgreen', fontWeight: '700'}}>Credited</div> : 
            row.PAYMENT_TYPE==='DEBIT' ? <div style={{color: 'red', fontWeight: '700'}}>Debited</div> : 
                <div style={{color: 'darkgreen', fontWeight: '700'}}>Refer Bonus</div>);
    };
    const showtoast = () => {
        toast.current.show({ severity: 'error', summary: 'Payment Failure', life: 3000 });
    }
    return(
        <Container className='container'>
            <Toast ref={toast} />
            <Row>
                {/* <Col xs={12}>
                    <div style={{textAlign: 'center', fontSize: '20px', fontWeight: '800'}}>User Wallet</div>
                </Col> */}
                <Col xs={12} className='d-flex justify-content-between bg_color_head p-2 align-items-center'>
                    <div>
                        <div style={{textAlign: 'left', fontSize: '18px', fontWeight: '700', color: '#fff'}}>
                            ATUM Wallet - ₹{parseFloat(userData.TOTAL_WALLET_AMOUNT).toFixed(2)}
                        </div>
                        <div style={{textAlign: 'left', fontSize: '13px', marginTop: '1%', color: '#fff'}}>
                            ATUM {userData.TOTAL_ATUM_COINS <=1 ? 'Coin' : 'Coins'} - {userData.TOTAL_ATUM_COINS}
                        </div>
                    </div>
                    <div className='d-flex justify-content-between'>
                    <div className="mx-1">
                    <Form.Group controlId='name'>
                      <Form.Control
                        type='name'
                        placeholder='Enter Amount'
                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                        value={addAmount}
                        onChange={(e) => setAddAmount(e.target.value)}
                        style={{borderRadius: '5px', textAlign: 'center'}}
                      ></Form.Control>
                    </Form.Group>
                    </div>
                    <div>
                        <Button style={{color: '#77cab9', backgroundColor: '#fff', border: '1px solid #fff', borderRadius: '5px', fontSize: '16px', fontWeight: '900'}} 
                        onClick={() => addAmountToWallet()}>Add to Wallet</Button>
                    </div>
                    </div>
                </Col>
                <Col xs={12} style={{marginTop: '15px'}}>
                    <DataTable value={walletTransactions} >
                        <Column header='Transaction' field="TRANSACTION_ID" />
                        <Column header='Payments' field='PAYMENT_TYPE' body={ptBody} />
                        <Column header='Amount' field='ORDER_AMOUNT' body={amtBody} />
                        <Column header='Created on' field='CREATED_AT' body={dateBody}  />
                    </DataTable>
                </Col>
            </Row>
        </Container>
    );
}
export default Wallet;